import React from 'react';

const Footer = () => {
  return <footer>&copy; {new Date().getFullYear()} www.naira.hay.land</footer>;
};

export default Footer;
